// api/DendreoSyncInvoiceRequest.ts
import { Model, Attr } from 'spraypaint';
import ApplicationRecord from '../ApplicationRecord';

@Model()
class DendreoSyncInvoiceRequest extends ApplicationRecord {
  static jsonapiType = 'dendreo-sync_invoice_requests';

  // Attributes
  @Attr() invoiceNumber!: string;

  // Extra-attributes

  // Relationships
}

export default DendreoSyncInvoiceRequest;
